import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Lang } from '../utils/translations';
import './LegalPages.css';

export default function PrivacyPage() {
  const [lang, setLang] = useState<Lang>(() => (localStorage.getItem('cartz_lang') as Lang) || 'en');
  const isRTL = lang === 'ar';

  const toggleLang = () => {
    const newLang = lang === 'en' ? 'ar' : 'en';
    setLang(newLang);
    localStorage.setItem('cartz_lang', newLang);
  };

  return (
    <div className="legal-page" dir={isRTL ? 'rtl' : 'ltr'}>
      <nav className="legal-nav">
        <div className="legal-nav-inner">
          <Link to="/" className="landing-logo">
            <img className="cartz-mark" src="/favicon.svg" alt="" />
            <span className="logo-text">Cartz</span>
          </Link>
          <button className="sf-lang-toggle" onClick={toggleLang}>
            {lang === 'en' ? 'عربي' : 'English'}
          </button>
        </div>
      </nav>

      <div className="legal-content">
        {lang === 'ar' ? (
          <>
            <h1>سياسة الخصوصية</h1>
            <p className="legal-updated">آخر تحديث: 28 مارس 2026</p>

            <h2>1. المعلومات التي نجمعها</h2>
            <p>نجمع المعلومات التي تقدمها لنا مباشرة عند إنشاء حساب أو متجر، بما في ذلك الاسم والبريد الإلكتروني ومعلومات المتجر. كما نجمع معلومات الاستخدام تلقائياً.</p>

            <h2>2. كيف نستخدم المعلومات</h2>
            <p>نستخدم المعلومات المجمعة لتوفير وتحسين خدماتنا، معالجة الطلبات، التواصل معك، وتخصيص تجربتك على المنصة.</p>

            <h2>3. مشاركة المعلومات</h2>
            <p>لا نبيع معلوماتك الشخصية لأطراف ثالثة. قد نشارك المعلومات مع مقدمي الخدمات الذين يساعدوننا في تشغيل المنصة، أو عند الضرورة القانونية.</p>

            <h2>4. أمن البيانات</h2>
            <p>نتخذ إجراءات أمنية معقولة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو التغيير أو الإفصاح أو الإتلاف.</p>

            <h2>5. ملفات تعريف الارتباط</h2>
            <p>نستخدم ملفات تعريف الارتباط وتقنيات مشابهة لتحسين تجربة المستخدم وتحليل استخدام الموقع.</p>

            <h2>6. بيانات المتجر والعملاء</h2>
            <p>أصحاب المتاجر مسؤولون عن حماية بيانات عملائهم وفقاً للقوانين المعمول بها. نوفر الأدوات اللازمة لمساعدتك في ذلك.</p>

            <h2>7. حقوقك</h2>
            <p>لديك الحق في الوصول إلى معلوماتك الشخصية وتصحيحها أو حذفها. يمكنك أيضاً طلب نسخة من بياناتك أو طلب حذف حسابك.</p>

            <h2>8. التعديلات</h2>
            <p>قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات جوهرية عبر البريد الإلكتروني أو إشعار على المنصة.</p>

            <h2>9. التواصل</h2>
            <p>لأي استفسارات حول سياسة الخصوصية، يرجى مراسلتنا على privacy@cartz.cc</p>
          </>
        ) : (
          <>
            <h1>Privacy Policy</h1>
            <p className="legal-updated">Last updated: March 28, 2026</p>

            <h2>1. Information We Collect</h2>
            <p>We collect information you provide directly when creating an account or store, including your name, email, and store information. We also automatically collect usage information.</p>

            <h2>2. How We Use Information</h2>
            <p>We use collected information to provide and improve our services, process orders, communicate with you, and personalize your experience on the platform.</p>

            <h2>3. Information Sharing</h2>
            <p>We do not sell your personal information to third parties. We may share information with service providers who help us operate the platform, or when legally required.</p>

            <h2>4. Data Security</h2>
            <p>We take reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.</p>

            <h2>5. Cookies</h2>
            <p>We use cookies and similar technologies to improve user experience and analyze site usage.</p>

            <h2>6. Store and Customer Data</h2>
            <p>Store owners are responsible for protecting their customers' data in accordance with applicable laws. We provide the necessary tools to help you with this.</p>

            <h2>7. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal information. You can also request a copy of your data or request account deletion.</p>

            <h2>8. Modifications</h2>
            <p>We may update this privacy policy from time to time. We will notify you of any material changes via email or platform notification.</p>

            <h2>9. Contact</h2>
            <p>For any questions about this privacy policy, please email us at privacy@cartz.cc</p>
          </>
        )}
      </div>
    </div>
  );
}
